export const serviceName = 'veriskEDI';
